export const lists = ["minhas", "empresa", "arquivadas"] as const;
type List = (typeof lists)[number];

export function listOf(query: URLSearchParams): List {
  const asked = query.get("lista");
  return lists.find((list) => list === asked) ?? "minhas";
}

export function listQuery(query: URLSearchParams): Readonly<Record<string, string | undefined>> {
  const lista = listOf(query);
  const busca = query.get("busca")?.trim();
  return { lista: lista === "minhas" ? undefined : lista, busca: busca === undefined || busca === "" ? undefined : busca };
}

export function listHref(lista: List, busca?: string): string {
  const params = new URLSearchParams();
  if (lista !== "minhas") params.set("lista", lista);
  if (busca !== undefined && busca.trim() !== "") params.set("busca", busca.trim());
  const search = params.toString();
  return search === "" ? "/conversas" : `/conversas?${search}`;
}
